import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

// Sélecteur hérité de `@wizbii/angular-ui`, déjà écrit tel quel dans 40 gabarits.
@Component({
  /* eslint-disable-next-line @angular-eslint/component-selector */
  selector: 'svg-icon',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (width()) {
      <svg
        class="svg-icon"
        [ngClass]="classes()"
        [attr.width]="width()"
        [attr.height]="height() || width()"
        [attr.viewBox]="viewBox()"
        [attr.preserveAspectRatio]="preserveAspectRatio()"
        [attr.role]="label() ? 'img' : 'presentation'"
        [attr.aria-label]="label()"
        focusable="false"
      >
        <use [attr.xlink:href]="iconId"></use>
      </svg>
    }
  `,
  styles: [
    `
      :host {
        display: inline-block;
        vertical-align: middle;
      }

      .svg-icon {
        display: block;
        fill: currentcolor;
        border: 0;
      }
    `,
  ],
})
export class SvgIconComponent {
  readonly icon = input.required<string>();
  readonly label = input('');
  readonly classes = input<string | string[]>('');
  readonly width = input.required<string>();
  readonly height = input<string>();
  readonly viewBox = input<string>();
  readonly preserveAspectRatio = input('xMinYMax meet');

  get iconId(): string {
    return `#icon-${this.icon()}`;
  }
}
